import { useId, useState, type FormEvent } from 'react';
import { LiksButton } from '../LiksButton/LiksButton';
import { LiksDialog } from '../LiksDialog/LiksDialog';
import './ChatSessionRenameDialog.css';

type ChatSessionSystemPromptDialogProps = {
  isOpen: boolean;
  initialValue: string;
  title: string;
  inputLabel: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: (value: string) => void;
  onCancel: () => void;
};

export function ChatSessionSystemPromptDialog({
  isOpen,
  ...rest
}: ChatSessionSystemPromptDialogProps) {
  if (!isOpen) {
    return null;
  }

  return <ChatSessionSystemPromptDialogContent {...rest} />;
}

type ChatSessionSystemPromptDialogContentProps = Omit<
  ChatSessionSystemPromptDialogProps,
  'isOpen'
>;

function ChatSessionSystemPromptDialogContent({
  initialValue,
  title,
  inputLabel,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}: ChatSessionSystemPromptDialogContentProps) {
  const inputId = useId();
  const [value, setValue] = useState(initialValue);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onConfirm(value);
  };

  return (
    <LiksDialog
      isOpen
      as="form"
      size="md"
      title={title}
      onClose={onCancel}
      onSubmit={handleSubmit}
      footer={
        <>
          <LiksButton variant="secondary" type="button" onClick={onCancel}>
            {cancelLabel}
          </LiksButton>
          <LiksButton variant="primary" type="submit">
            {confirmLabel}
          </LiksButton>
        </>
      }
    >
      <label className="liks-chat-session-rename__label" htmlFor={inputId}>
        {inputLabel}
      </label>
      <textarea
        id={inputId}
        className="liks-chat-session-rename__input liks-chat-session-rename__textarea"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        rows={8}
        autoFocus
      />
    </LiksDialog>
  );
}
